"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNKNOWN_SURCHARGE_TOOLTIP = exports.SURCHARGE_TEXT = exports.SMALL_CARD_SURCHARGE_TEXT = exports.KNOWN_SURCHARGE_TOOLTIP = void 0;

var _localization = require("@lt/localization");

var KNOWN_SURCHARGE_TOOLTIP = _localization.i18n.t('hotelcard.card.constants.known');

exports.KNOWN_SURCHARGE_TOOLTIP = KNOWN_SURCHARGE_TOOLTIP;

var UNKNOWN_SURCHARGE_TOOLTIP = _localization.i18n.t('hotelcard.card.constants.unknown');

exports.UNKNOWN_SURCHARGE_TOOLTIP = UNKNOWN_SURCHARGE_TOOLTIP;

var SMALL_CARD_SURCHARGE_TEXT = _localization.i18n.t('hotelcard.card.constants.small');

exports.SMALL_CARD_SURCHARGE_TEXT = SMALL_CARD_SURCHARGE_TEXT;

var SURCHARGE_TEXT = _localization.i18n.t('hotelcard.card.constants.surcharge');

exports.SURCHARGE_TEXT = SURCHARGE_TEXT;